import * as Html from "../util/Html.ts";
import ApiServer from "../ApiServer.js";

export {init}
Html.registerWidget('widget/deeploginlink',{init:init})

function init(obj){
  obj.children().hide();
  ApiServer.accgenerateDeepLoginLink("home.php",true,function(link){
    if(link){
      obj.attr('href',link);
      obj.children().first().show();
    }else{
      var defClick;
      if((defClick=obj.attr('data-fw-onclickifnolink'))!==null){
        obj.attr('data-fw-onclick',defClick)
      }
      obj.text(obj.attr('data-fw-textifnolink'));
      obj.children().last().show();
    }
  });
}